export default __webpack_public_path__ + "static/media/Step1.8c92b34f.png";